export const consentType = {
    PG_TO_PAYUFIN:"pg_to_payufin_flexicash"
}
